<template>
<div class="pageLayoutBox">
    <div class="pageNav" :style="{ width: !isCollapse ? '200px' : '60px' }">
        <div class="logo-box">
            <img class="logo-white" src="../../assets/logo-white.svg" v-if="!isCollapse" />
            <img class="logo-menu" src="../../assets/menu-icon.svg" @click="toggleMenu" />
        </div>
        <el-menu :default-active="defaultActive" ref="mainMenu" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :collapse="isCollapse" :unique-opened="true" :collapse-transition="false" :router="true" @select="handleSelect">
            <el-submenu index="0" :route="{ path: '/index' }" class="indexNav">
                <template slot="title">
                    <div class="titleIcon" @click="jumpHome()">
                        <img src="../../assets/home.svg" alt class="menuIcon" v-if="openKey == 0" />
                        <img src="../../assets/home1.svg" alt class="menuIcon" v-else />
                    </div>
                    <span slot="title" class="navTitleText" @click="jumpHome()">首页</span>
                </template>
            </el-submenu>
            <el-submenu index="1">
                <template slot="title">
                    <div class="titleIcon">
                        <img src="../../assets/live.svg" alt class="menuIcon" v-if="openKey == 1" />
                        <img src="../../assets/live1.svg" alt class="menuIcon" v-else />
                    </div>
                    <span slot="title" class="navTitleText">直播管理</span>
                </template>
                <el-menu-item index="1-1" :route="{ path: '/live/list' }">直播列表</el-menu-item>
                <el-menu-item index="1-2" :route="{ path: '/live/add' }">创建直播</el-menu-item>
            </el-submenu>
            <el-submenu index="2">
                <template slot="title">
                    <div class="titleIcon">
                        <img src="../../assets/demand.svg" alt class="menuIcon" v-if="openKey == 2" />
                        <img src="../../assets/demand1.svg" alt class="menuIcon" v-else />
                    </div>
                    <span slot="title" class="navTitleText">点播管理</span>
                </template>
                <el-menu-item index="2-1" :route="{ path: '/onDemand/list' }">点播列表</el-menu-item>
                <el-menu-item index="2-2" :route="{ path: '/onDemand/add' }">创建点播</el-menu-item>
            </el-submenu>
            <el-submenu index="3">
                <template slot="title">
                    <div class="titleIcon">
                        <img src="../../assets/finance.svg" alt class="menuIcon" v-if="openKey == 3" />
                        <img src="../../assets/finance1.svg" alt class="menuIcon" v-else />
                    </div>
                    <span slot="title" class="navTitleText">财务中心</span>
                </template>
                <el-menu-item index="3-1" :route="{ path: '/finance/balance' }">余额</el-menu-item>
                <el-menu-item index="3-2" :route="{ path: '/finance/deduction' }">扣费记录</el-menu-item>
                <el-menu-item v-if="!!sponsor.showRecharge" index="3-3" :route="{ path: '/finance/recharge' }">购买充值</el-menu-item>
            </el-submenu>
            <el-submenu index="4">
                <template slot="title">
                    <div class="titleIcon">
                        <img src="../../assets/account.svg" alt class="menuIcon" v-if="openKey == 4" />
                        <img src="../../assets/account1.svg" alt class="menuIcon" v-else />
                    </div>
                    <span slot="title" class="navTitleText">账号设置</span>
                </template>
                <el-menu-item index="4-1" :route="{ path: '/account/info' }">账号信息</el-menu-item>
                <!--<el-menu-item index="4-2" :route="{ path: '/account/certification' }">企业认证</el-menu-item>-->
                <el-menu-item index="4-3" :route="{ path: '/account/message' }">消息</el-menu-item>
                <el-menu-item index="4-4" :route="{ path: '/account/feedback' }">反馈</el-menu-item>
            </el-submenu>
        </el-menu>
    </div>
    <div class="pageRightBox" :style="{ 'padding-left': !isCollapse ? '200px' : '60px' }">
        <div class="pageHeader">
            <div class="left" v-html="breadcrumbsEnums[path]"></div>
            <div class="right">
                <a class="box" :href="homeURI" target="_blank">
                    <!--<img src="../../assets/home1.svg" alt class="downloadIcon" />-->
                    <i class="el-icon-s-home homeIcon"></i>
                    <span>我的首页</span>
                </a>
                <a class="box messIcon" @click="goMessage">
                    <img src="../../assets/message.svg" alt class="messageIcon" />
                    <span class="actIcon" v-if="newMessageCount>0"></span>
                    <span>消息</span>
                </a>
                <div class="box headerPhotoBox loginAfter" @mouseenter="headerMenuEnter()" @mouseleave="headerMenuLeave()">
                    <div class="avatar"><img class="headerPhoto" alt="" :src="sponsor.portrait" /></div>
                    <div class="headerMenuBox" v-if="showHeaderMenuFlag">
                        <div class="headerMenu">
                            <div class="userInfo">
                                <img class="headerPhoto" :src="sponsor.portrait" alt="" />
                                <div class="nameBox">
                                    <p><a href="javascript:;">{{sponsor.nickName}}</a></p>
                                    <p>{{sponsor.intro}}</p>
                                </div>
                            </div>
                            <div class="menuItem">
                                <a @click="goChannel">
                                    <img src="../../assets/myLiveIcon.svg" alt="" />我的直播
                                </a>
                            </div>
                            <div class="menuItem">
                                <a @click="goVod">
                                    <img src="../../assets/myDibblingIcon.svg" alt="" />我的点播
                                </a>
                            </div>
                            <div class="menuItem last">
                                <a @click="goSettings">
                                    <img src="../../assets/myAccountIcon.svg" alt="" /> 账号设置
                                </a>
                            </div>
                            <div class="logout" @click="logoff">退出</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pageContent">
            <router-view />
        </div>
    </div>
</div>
</template>

<script>
    import common from '../../common.vue';

    export default {
        name: "Layout",

        data() {
            return {
                isCollapse: false,
                openKey: 0,
                showHeaderMenuFlag: false,
                breadcrumbsEnums: {
                    "/finance/balance": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 财务中心 > 余额</div>',
                    "/finance/deduction": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 财务中心 > 扣费记录</div>',
                    "/finance/recharge": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 财务中心 > 购买充值</div>',
                    "/finance/number": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 财务中心 > 提交订单</div>',
                    "/finance/pay": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 财务中心 > 支付</div>',
                    "/finance/my-order": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 财务中心 > 我的订单</div>',
                    "/finance/invoicing": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 财务中心 > 开票</div>',
                    "/account/info": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 账号设置 > 账号信息</div>',
                    "/account/certification": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 账号设置 > 企业认证</div>',
                    "/account/message": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 账号设置 > 消息</div>',
                    "/account/feedback": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 账号设置 > 反馈</div>',
                    "/onDemand/list": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 点播管理 > 点播列表</div>',
                    "/onDemand/edit": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 点播管理 > 创建点播</div>',
                    "/onDemand/file": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 点播管理 > 点播文件</div>',
                    "/onDemand/statistics": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 点播管理 > 监控统计</div>',
                    "/live/list": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 直播管理 > 直播列表</div>',
                    "/live/edit": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 直播管理 > 直播编辑</div>',
                    "/live/history": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 直播管理 > 直播历史</div>',
                    "/live/share": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 直播管理 > 频道分享</div>',
                    "/live/launch": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 直播管理 > 发起直播</div>',
                    "/live/statistics": '<div class="breadcrumbs"><router-link to="/index">首页</router-link> > 直播管理 > 监控统计</div>',
                    "/index": "欢迎使用Quicklive管理系统",
                },
                path: "",
                // 用户信息
                sponsor: {},
                // 首页链接
                homeURI: '',
                portrait: '',
                newMessageCount: 0,
                defaultActive: '0'
            };
        },

        watch: {
            //$route(to, from) {
            $route(to) {
                this.path = to.path;
            },
        },

        methods: {
            handleOpen(key) {
                console.log(key);
                this.openKey = key;
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            },
            handleSelect(key) {
                if (key.length > 1) {
                    this.openKey = key.split("-")[0];
                } else {
                    this.openKey = key;
                }
            },
            toggleMenu() {
                this.isCollapse = this.isCollapse ? false : true;
            },
            headerMenuEnter() {
                this.showHeaderMenuFlag = true;
            },
            headerMenuLeave() {
                this.showHeaderMenuFlag = false;
            },
            jumpHome() {
                this.path != "/index" && this.$router.push(`/index`);
            },
            logoff() {
                let _this = this;
                _this.$axios(common._BASE_ + 'sponsor/logoff').then(function () {
                    _this.$router.push('/login');
                });
            },
            goChannel(){
                this.openKey = 1;
                this.defaultActive = '1-1';
                this.$router.push('/live/list');
                this.showHeaderMenuFlag = false;
            },
            goVod(){
                this.openKey = 2;
                this.defaultActive = '2-1';
                this.$router.push('/onDemand/list');
                this.showHeaderMenuFlag = false;
            },
            goSettings(){
                this.openKey = 4;
                this.defaultActive = '4-1';
                this.$router.push('/account/info');
                this.showHeaderMenuFlag = false;
            },
            goMessage(){
                this.openKey = 4;
                this.defaultActive = '4-3';
                this.$router.push('/account/message');
            },
            // 获取登录用户信息，如果无效，返回登录页
            getSponsorInfo(){
                let _this = this;
                _this.$axios.post(common._BASE_ + '/sponsor/getLogonInfo').then(function (res) {
                    let r = res.data;
                    if(r.code !== 0){
                        _this.$router.push('/login');
                    }else{
                        _this.sponsor = r.data;
                        let t = r.tag || '';
                        _this.homeURI = (t !== '')? '/home?t=' + t : '/home?uid=' + r.data.sponsorId;
                        localStorage.setItem('balance', JSON.stringify(r.balance));
                        localStorage.setItem('sponsor', JSON.stringify(r.data));
                        _this.breadcrumbsEnums['/index'] = "<span class='userName'>" + _this.sponsor.nickName + "</span>欢迎使用Quicklive管理系统";
                        _this.newMessageCount = r.message;
                    }
                });
            }
        },

        beforeCreate() {
        },
        mounted() {
            this.path = this.$router.history.current.path;
            this.getSponsorInfo();
        },
    };
</script>

<style lang="less">
    .pageLayoutBox {
        width: 100%;
        height: 100%;
    }

    .pageRightBox {
        flex: 1;
        background: #f5f6f7;
        padding-left: 200px;

        .pageHeader {
            height: 60px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px;

            .left,
            .right {
                display: flex;
                align-items: center;
            }

            .left {
                font-size: 12px;
                font-weight: 400;
                line-height: 50px;
                color: #a2a9ab;

                .userName {
                    color: #4aa3f8;
                }
            }

            .box {
                display: flex;
                align-items: center;
                cursor: pointer;
                color: #55565f;
                position: relative;

                .homeIcon {
                    margin-right: 5px;
                    font-size: 26px;
                    color: #66677f;
                }

                .messageIcon {
                    margin-right: 6px;
                    margin-left: 12px;
                }

                .actIcon {
                    width: 10px;
                    height: 10px;
                    background: #dc5986;
                    border-radius: 50%;
                    position: absolute;
                    top: -3px;
                    left: 20px;
                }
            }

            a.box:hover {
                color: #306ff6;
            }

            .headerPhotoBox {
                width: 36px;
                height: 36px;
                border-radius: 50%;
                margin-left: 18px;
                box-sizing: border-box;
                .avatar {
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                    border: 1px solid #e8e8e8;
                    overflow: hidden;
                }
                .headerPhoto {
                    display: block;
                    width: 100%;
                    height: auto;
                    border-radius: 50%;
                    cursor: pointer;
                }

                .nameBox p {
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }

                .headerMenuBox {
                    position: absolute;
                    z-index: 1000;
                    height: 213px;
                    // display: none;
                    padding-top: 10px;
                    background: transparent;
                    right: 0px;
                    top: 30px;
                    overflow: hidden;
                }

                .headerMenu {
                    width: 174px;
                    height: 203px;
                    background: #fff;
                    border: 1px solid #f5f6f7;
                    opacity: 1;
                    border-radius: 4px;
                    padding: 0 12px 0 8px;

                    .userInfo {
                        display: flex;
                        align-items: center;
                        height: 57px;
                        border-bottom: 1px solid #f5f6f7;

                        a {
                            color: #55565f;
                        }

                        a:hover {
                            color: #306ff6;
                        }
                    }

                    .userInfo img {
                        width: 41px;
                        height: 41px;
                        margin-right: 8px;
                    }

                    .userInfo p:last-child {
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 21px;
                        color: #c1c5c5;
                        width: 95px;
                    }

                    .userInfo p:first-child {
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 21px;
                        color: #221816;
                    }

                    .menuItem {
                        height: 36px;
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 21px;
                        color: #221816;
                        padding-left: 8px;
                        cursor: pointer;
                    }

                    .menuItem a {
                        color: #221816;
                    }

                    .menuItem a:hover {
                        color: #306ff6;
                    }

                    .menuItem.last {
                        border-bottom: 1px solid #f5f6f7;
                    }

                    .menuItem img {
                        width: 16px;
                        margin-right: 14px;
                    }

                    .logout {
                        font-size: 14px;
                        font-weight: 400;
                        color: #33363f;
                        text-align: center;
                        margin-top: 8px;
                        cursor: pointer;
                    }

                    .logout:hover {
                        color: #306ff6;
                    }
                }

                .searchHistory {
                    margin-bottom: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                }

                .searchHistory a {
                    min-width: 96px;
                    height: 24px;
                    font-size: 12px;
                    line-height: 24px;
                    color: #221816;
                }

                .searchHistory a:last-child {
                    margin-right: 0;
                }

                .loginBtnWrap {
                    width: 160px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                .headerSearch .loginBtn {
                    display: inline-block;
                    width: 60px;
                    height: 36px;
                    border-radius: 4px;
                    color: #55565f;
                    font-size: 14px;
                    line-height: 36px;
                    text-align: center;
                    border: solid 1px #707070;
                }

                .headerSearch .loginBtn:hover {
                    color: #fff;
                    background: #306ff6;
                    border: solid 1px #306ff6;
                }

                .headerSearch .tryoutBtn {
                    display: inline-block;
                    width: 90px;
                    height: 36px;
                    background: #306ff6;
                    border-radius: 4px;
                    color: #fff;
                    font-size: 14px;
                    line-height: 36px;
                    text-align: center;
                }

                .headerSearch .tryoutBtn:hover {
                    background: #4aa3f8;
                }
            }
        }
    }

    .pageNav {
        width: 200px;
        height: 100%;
        background: #1a1a1a;
        overflow: hidden;
        position: fixed;
        top: 0;
        left: 0;
    }

    .logo-box {
        height: 60px;
        background: #306ff6;
        display: flex;
        align-items: center;
        justify-content: center;

        .logo-white {
            width: 138px;
            margin-right: 12px;
        }

        .logo-menu {
            width: 17px;
            margin-top: 2px;
            cursor: pointer;
        }
    }

    .indexNav {
        .el-submenu__icon-arrow {
            display: none;
        }
    }

    .navTitleText {
        display: block;
        height: 50px;
        line-height: 50px;
    }

    .titleIcon {
        width: 21px;
        height: 50px;
        position: absolute;
        top: 0;
        left: 18px;
        display: flex;
        align-items: center;
    }

    .titleIcon img {
        display: block;
        margin: 0 auto;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto 0;
    }

    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
        min-height: 400px;
    }

    .el-menu--collapse {
        width: 60px;

        .el-submenu__title {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .el-menu {
        background: transparent !important;
        border: none !important;
    }

    .el-submenu__title {
        height: 50px;
        line-height: 50px;
        padding: 0 0 0 50px !important;
        position: relative;
    }

    .el-submenu__title,
    .el-menu-item {
        color: #fff;
        font-size: 16px;
    }

    .is-opened .el-submenu__title {
        color: #4aa3f8;
    }

    .el-submenu__title:hover,
    .el-menu-item:hover {
        background: transparent;
        color: #4aa3f8;
    }

    .el-submenu .el-menu-item {
        height: 40px;
        line-height: 40px;
        padding-left: 50px !important;
    }

    .el-menu-item.is-active {
        background: #333336;
        border-left: solid 3px #4aa3f8;
        padding-left: 47px !important;
        color: #4aa3f8;
    }

    .el-menu--vertical {
        background: #1a1a1a;
        width: 80px;
        padding: 0 !important;
        text-align: center;
        border-radius: 4px;
        margin-left: 5px;
        margin-top: 18px;
        overflow: hidden;
    }

    .el-menu--popup-right-start {
        margin: 0;
    }

    .el-menu--popup {
        padding: 0;
        min-width: 80px;
    }

    .el-menu--popup .el-menu-item {
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        padding: 0 !important;
    }

    .el-menu--popup .el-menu-item.is-active {
        background: #000000;
        border-left: none;
        padding: 0px !important;
        text-align: center;
        color: #4aa3f8;
    }
</style>
